import React, {useState, useEffect} from "react";
import {withTranslation} from "react-i18next";
import "../center.scss";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {Button, Form, Input, Space, Select} from "antd";
import {PlusOutlined, MinusCircleOutlined} from "@ant-design/icons";
import {xcService} from "../../../_services/xcService";

function StepTwoCenter(props) {
  const storage = localOrSessionStore({key: variables.REMEMBER});
  const user = JSON.parse(storage.getItem(variables.USER));
  const [form] = Form.useForm();
  const {t, i18n} = props;
  const [loading, setLoading] = useState(false);

  const [number, setNumber] = useState(1);

  const onFinish = (vals) => {
    props.goTo(vals, 2);
  };

  const [documentType, setDocumentType] = useState("DNI");
  const [orientadoresDocType, setOrientadoresDocType] = useState({});

  const [documentTypeDirector, setDocumentTypeDirector] = useState("DNI");
  const handleDocumentTypeChange = (value) => {
      setDocumentType(value);
      if (value === "DNI") {
          form.setFieldsValue({ orientadornie: null });
      } else {
          form.setFieldsValue({ orientadordni: null });
      }
  };

  const handleDocumentTypeChangeDirector = (value) => {
    setDocumentTypeDirector(value);
    if (value === "DNI") {
        form.setFieldsValue({ directorNie: null });
    } else {
        form.setFieldsValue({ directorDni: null });
    }
  };

  const handleOrientadorDocTypeChange = (index, value) => {
    setOrientadoresDocType(prev => ({ ...prev, [index]: value }));
    const current = form.getFieldValue("orientadores") || [];
    if (value === "DNI") {
      current[index] = { ...current[index], nie: null };
    } else {
      current[index] = { ...current[index], dni: null };
    }
    form.setFieldsValue({ orientadores: current });
  };

  useEffect(() => {
    xcService.get("/v1/tutor/contractemp/" + user.code).then((data) => {
      if (data.data.data && data.data.data.code) {
        const {setFieldsValue, getFieldValue} = form;
        try {
          let mData = JSON.parse(data.data.data.values2);
          mData.orientadordocumentType = mData?.orientadordocumentType || "DNI";
          mData.directordocumentType = mData?.directordocumentType || "DNI";
          handleDocumentTypeChange(mData?.orientadordocumentType);
          handleDocumentTypeChangeDirector(mData?.directordocumentType);
          setFieldsValue(mData);

          if(mData.orientadores) {
            const docTypes = {};
            mData.orientadores.forEach((o, idx) => {
              docTypes[idx] = o.documentType || "DNI";
            });
            setOrientadoresDocType(docTypes);
          }
        } catch (e) {
          console.error(e);
        }
      }
    });
  }, [user.code, form]);

  return (
    <Form
      className="authForm allHeightMobile"
      form={form}
      onFinish={onFinish}
      name="basic"
      layout="vertical"
      initialValues={{remember: true, directordocumentType: "DNI", orientadordocumentType: "DNI"}}
      autoComplete="off"
    >
      <div className={"customLabel"} style={{marginBottom: 10}}>
        {t("registercenter.director.title")}
      </div>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.director.nombre")}
        name={"directorName"}
      >
        <Input placeholder={t("registercenter.placenom")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.director.apellidos")}
        name={"directorSurname"}
      >
        <Input placeholder={t("registercenter.placesur")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            type: "email",
            message: t("registro.emailIncorrect"),
          },
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.director.email")}
        name={"directorEmail"}
      >
        <Input placeholder={t("registercenter.placeemail")} />
      </Form.Item>

      <Form.Item
        name="directordocumentType"
        label={
          <div>
            <span>{t("registro.documentType")}</span>&nbsp;&nbsp;
          </div>
        }
        hasFeedback
        rules={[{ required: true, message: t("mandatory") }]}
        >
          <Select onChange={(value) => handleDocumentTypeChangeDirector(value)}>
            <Option value="DNI">{t("registro.dni")}</Option>
            <Option value="NIE">{t("registro.nie")}</Option>
          </Select>
      </Form.Item>


      {documentTypeDirector === "DNI" && (
        <Form.Item
          rules={[
            {
              required: true,
              message: t("mandatory"),
            },
            ({getFieldValue}) => ({
              validator(_, value) {
                var DNI_REGEX = /^(\d{8})([A-Z])$/;
                value = value.toUpperCase().replace(/\s/, "");
                if (value.match(DNI_REGEX)) {
                  var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                  var letter = dni_letters.charAt(parseInt(value, 10) % 23);
                  if (letter === value.charAt(8)) return Promise.resolve();
                  else return Promise.reject(new Error(t("registro.baddni")));
                } else {
                  return Promise.reject(new Error(t("registro.baddni")));
                }
              },
            }),
          ]}
          label={t("registercenter.director.dni")}
          name={"directorDni"}
        >
          <Input placeholder={"1234567X"} />
        </Form.Item>
      )}


      {documentTypeDirector === "NIE" && (
        <Form.Item
            label={t("registro.nie")}
            name="directorNie"
            rules={[
                { required: true, message: t("mandatory") },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const NIE_REGEX = /^[XYZ][0-9]{7}[A-Z]$/i;
                    const cleaned = value.toUpperCase().replace(/\s/g, '');
                    if (!cleaned.match(NIE_REGEX)) {
                      return Promise.reject(new Error(t("registro.badnie")));
                    }
                      // Transformar la letra inicial a número
                    const nie_letters_map = { X: '0', Y: '1', Z: '2' };
                    const numberPart = nie_letters_map[cleaned.charAt(0)] + cleaned.slice(1, 8);
                    const dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                    const controlLetter = dni_letters.charAt(parseInt(numberPart, 10) % 23);
                    return controlLetter === cleaned.charAt(8)
                        ? Promise.resolve()
                        : Promise.reject(new Error(t("registro.badnie")));
                  },
                }),
            ]}
        >
            <Input placeholder="X1234567X" />
        </Form.Item>
      )}


      <div className={"customLabel"} style={{marginTop: 20, marginBottom: 10}}>
        {t("registercenter.jefe.title")}
      </div>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.jefe.nombre")}
        name={"jefeName"}
      >
        <Input placeholder={t("registercenter.placenom")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.jefe.apellidos")}
        name={"jefeSurname"}
      >
        <Input placeholder={t("registercenter.placesur")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            type: "email",
            message: t("registro.emailIncorrect"),
          },
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.jefe.email")}
        name={"jefeEmail"}
      >
        <Input placeholder={t("registercenter.placeemail")} />
      </Form.Item>

      <div className={"customLabel"} style={{marginTop: 20, marginBottom: 10}}>
        {t("registercenter.orientador.title")}
      </div>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.orientador.nombre") + " " + parseInt(1)}
        name={"orientadornombre"}
      >
        <Input placeholder={t("registercenter.placenom")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.orientador.apellidos") + " " + parseInt(1)}
        name={"orientadorapellidos"}
      >
        <Input placeholder={t("registercenter.placesur")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            type: "email",
            message: t("registro.emailIncorrect"),
          },
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.orientador.email") + " " + parseInt(1)}
        name={"orientadoremail"}
      >
        <Input placeholder={t("registercenter.placeemail")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.orientador.telefm") + " " + parseInt(1)}
        name={"orientadortelef"}
      >
        <Input placeholder={"XXX-XXX-XXX"} />
      </Form.Item>

      <Form.Item
        name="orientadordocumentType"
        label={
          <div>
            <span>{t("registro.documentType") + " " + parseInt(1)}</span>&nbsp;&nbsp;
          </div>
        }
        hasFeedback
        rules={[{ required: true, message: t("mandatory") }]}
        >
          <Select onChange={(value) => handleDocumentTypeChange(value)}>
            <Option value="DNI">{t("registro.dni")}</Option>
            <Option value="NIE">{t("registro.nie")}</Option>
          </Select>
      </Form.Item>

      {documentType === "DNI" && (
        <Form.Item
          rules={[
            {
              required: true,
              message: t("mandatory"),
            },
            ({getFieldValue}) => ({
              validator(_, value) {
                var DNI_REGEX = /^(\d{8})([A-Z])$/;
                value = value.toUpperCase().replace(/\s/, "");
                if (value.match(DNI_REGEX)) {
                  var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                  var letter = dni_letters.charAt(parseInt(value, 10) % 23);
                  if (letter === value.charAt(8)) return Promise.resolve();
                  else return Promise.reject(new Error(t("registro.baddni")));
                } else {
                  return Promise.reject(new Error(t("registro.baddni")));
                }
              },
            }),
          ]}
          label={t("registercenter.orientador.dni") + " " + parseInt(1)}
          name={"orientadordni"}
        >
          <Input placeholder={"1234567X"} />
        </Form.Item>
      )}


      {documentType === "NIE" && (
        <Form.Item
            label={t("registro.nie") + " " + parseInt(1)}
            name="orientadornie"
            rules={[
                { required: true, message: t("mandatory") },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const NIE_REGEX = /^[XYZ][0-9]{7}[A-Z]$/i;
                    const cleaned = value.toUpperCase().replace(/\s/g, '');
                    if (!cleaned.match(NIE_REGEX)) {
                      return Promise.reject(new Error(t("registro.badnie")));
                    }
                      // Transformar la letra inicial a número
                    const nie_letters_map = { X: '0', Y: '1', Z: '2' };
                    const numberPart = nie_letters_map[cleaned.charAt(0)] + cleaned.slice(1, 8);
                    const dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                    const controlLetter = dni_letters.charAt(parseInt(numberPart, 10) % 23);
                    return controlLetter === cleaned.charAt(8)
                        ? Promise.resolve()
                        : Promise.reject(new Error(t("registro.badnie")));
                  },
                }),
            ]}
        >
            <Input placeholder="X1234567X" />
        </Form.Item>
      )}


      <Form.List name={"orientadores"}>
        {(fields, {add, remove}, {errors}) => (
          <>
            {fields.map((field, index) => (
              <>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: t("mandatory"),
                    },
                  ]}
                  label={t("registercenter.orientador.nombre") + " " + parseInt(index + 2)}
                  name={[field.name, "nombre"]}
                >
                  <Input placeholder={t("registercenter.placenom")} />
                </Form.Item>

                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: t("mandatory"),
                    },
                  ]}
                  label={t("registercenter.orientador.apellidos") + " " + parseInt(index + 2)}
                  name={[field.name, "apellidos"]}
                >
                  <Input placeholder={t("registercenter.placesur")} />
                </Form.Item>
                <Form.Item
                  rules={[
                    {
                      type: "email",
                      message: t("registro.emailIncorrect"),
                    },
                    {
                      required: true,
                      message: t("mandatory"),
                    },
                  ]}
                  label={t("registercenter.orientador.email") + " " + parseInt(index + 2)}
                  name={[field.name, "email"]}
                >
                  <Input placeholder={t("registercenter.placeemail")} />
                </Form.Item>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: t("mandatory"),
                    },
                  ]}
                  label={t("registercenter.orientador.telefm") + " " + parseInt(index + 2)}
                  name={[field.name, "telef"]}
                >
                  <Input placeholder={"XXX-XXX-XXX"} />
                </Form.Item>

                <Form.Item
                  name={[field.name, "documentType"]}
                  label={t("registro.documentType") + " " + parseInt(index + 2)}
                  rules={[{ required: true, message: t("mandatory") }]}
                >
                  <Select
                    value={orientadoresDocType[field.name] || "DNI"}
                    onChange={(value) => handleOrientadorDocTypeChange(field.name, value)}
                  >
                    <Option value="DNI">{t("registro.dni")}</Option>
                    <Option value="NIE">{t("registro.nie")}</Option>
                  </Select>
                </Form.Item>

                {orientadoresDocType[field.name] === "DNI" && (
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: t("mandatory"),
                      },
                      ({getFieldValue}) => ({
                        validator(_, value) {
                          var DNI_REGEX = /^(\d{8})([A-Z])$/;
                          value = value.toUpperCase().replace(/\s/, "");
                          if (value.match(DNI_REGEX)) {
                            var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                            var letter = dni_letters.charAt(parseInt(value, 10) % 23);
                            if (letter === value.charAt(8)) return Promise.resolve();
                            else return Promise.reject(new Error(t("registro.baddni")));
                          } else {
                            return Promise.reject(new Error(t("registro.baddni")));
                          }
                        },
                      }),
                    ]}
                    label={t("registercenter.orientador.dni") + " " + parseInt(index + 2)}
                    name={[field.name, "dni"]}
                  >
                    <Input placeholder={"1234567X"} />
                  </Form.Item>
                )}

                {orientadoresDocType[field.name] === "NIE" && (
                  <Form.Item
                    label={t("registro.nie") + " " + parseInt(index + 2)}
                    name={[field.name, "nie"]}
                    rules={[
                        { required: true, message: t("mandatory") },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const NIE_REGEX = /^[XYZ][0-9]{7}[A-Z]$/i;
                            const cleaned = value.toUpperCase().replace(/\s/g, '');
                            if (!cleaned.match(NIE_REGEX)) {
                              return Promise.reject(new Error(t("registro.badnie")));
                            }
                              // Transformar la letra inicial a número
                            const nie_letters_map = { X: '0', Y: '1', Z: '2' };
                            const numberPart = nie_letters_map[cleaned.charAt(0)] + cleaned.slice(1, 8);
                            const dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                            const controlLetter = dni_letters.charAt(parseInt(numberPart, 10) % 23);
                            return controlLetter === cleaned.charAt(8)
                                ? Promise.resolve()
                                : Promise.reject(new Error(t("registro.badnie")));
                          },
                        }),
                    ]}
                  >
                      <Input placeholder="X1234567X" />
                  </Form.Item>
                )}

                <Form.Item className="alignBottomMobile">
                  <Space size={180} className="btnsForm">
                    <Button
                      type={"warning"}
                      className="primaryButton"
                      onClick={() => remove(field.name)}
                      icon={<MinusCircleOutlined />}
                    >
                      {t("registercenter.orientador.remove")}
                    </Button>
                  </Space>
                </Form.Item>
              </>
            ))}
            <Form.Item className="alignBottomMobile">
              <Space size={180} className="btnsForm">
                <Button className="primaryButton"   onClick={() => {
                      const newIndex = form.getFieldValue("orientadores")?.length || 0;
                      add({ documentType: "DNI" });
                      handleOrientadorDocTypeChange(newIndex, "DNI");
                    }} 
                  icon={<PlusOutlined />}>
                  {t("registercenter.orientador.add")}
                </Button>
              </Space>
            </Form.Item>
          </>
        )}
      </Form.List>
      <Form.Item className="buttons-pre-next">
        <Button className="primaryButton buttonSizeS" onClick={() => props.goTo(null, 0)} htmlType="button">
          {t("atras")}
        </Button>
        <Button loading={loading} className="primaryButton buttonSizeS" type="primary" htmlType="submit">
          {t("next")}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default withTranslation()(StepTwoCenter);
